export class ZendeskIntegration {
  zendeskTicketId: string;
  zendeskUserId: string;
}
